import { render } from "./SelectImageModal.vue?vue&type=template&id=5891c66f"
import script from "./SelectImageModal.vue?vue&type=script&lang=js"
export * from "./SelectImageModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__